export default {
  container: {
    flexDirection: 'column',
  },
  titleContainer: {
    flexDirection: 'column',
    mb: '40px',
  },
  title: {
    m: 0,
  },
  titleBorder: {
    width: '70px',
    height: '4px',
    borderRadius: '8px',
    mt: '8px',
    backgroundColor: '#026AA2',
  },
  collectionContainer: {
    gap: '12px',
  },
  collectionText: {
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
  imagesStyles: {
    mt: 11,
  },
};
